import axios from 'axios';

export const migrateUserIds = async () => {
  try {
    const response = await axios.post('http://localhost:3001/api/admin/migrate-users');
    
    if (response.data.success) {
      console.log('Migration completed successfully:', response.data.stats);
      return response.data.stats;
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    console.error('Migration failed:', error);
    throw error;
  }
}; 